import { useCallback, useEffect, useRef, useState } from "react"
import { getEntityIdFromURL, getSlugFromURL } from "../utils"
import { FetchHelper } from "../utils/fetchHelper"

export const useAssetDetailExtensionV2 = (
    functionName,
    options = {},
    slug,
    apiEndpoint = "api/v1/asset-detail/extension",
) => {
    const { enabled = true, extraParams = {} } = options

    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    // ✅ prevent duplicate calls
    const inFlightRef = useRef(false)

    const fetchDetails = useCallback(
        async (overrideParams = {}) => {
            if (inFlightRef.current) return // 🚀 guard

            inFlightRef.current = true
            setIsLoading(true)

            try {
                const resp = await FetchHelper.get(
                    apiEndpoint, // url
                    {
                        slug: slug || getSlugFromURL(),
                        entity_id: getEntityIdFromURL(),
                        function_name: functionName,
                        ...extraParams,
                        ...overrideParams,
                    }, // params
                )
                if (resp?.data?.status) {
                    setData(resp.data)
                    return resp.data
                }
            } catch (err) {
                console.warn(`fetch ${functionName} error`, err)
                throw err
            } finally {
                inFlightRef.current = false // ✅ release lock
                setIsLoading(false)
            }
        },
        [functionName, enabled, extraParams, apiEndpoint, slug],
    )

    useEffect(() => {
        if (enabled) fetchDetails()
    }, [enabled]) // ✅ include fetchDetails

    return { data, isLoading, refetch: fetchDetails }
}
